const SectionTitle = () => import("../SectionTitle/SectionTitle.vue")
import agencyService from "@/services/agency";
import { mapGetters } from "vuex";

export default {
  name: "AgencyHome",
  components: {
    SectionTitle,
  },
  data() {
    return {
      agency: {
        address: "",
        city: "",
        email: "",
        lat: null,
        lng: null,
        name: null,
        openingHours: "",
        pkAgency: null,
        tel: "",
        website: "",
        zipCode: "",
      },
    };
  },
  async created() {
    await this.getMyAgency();
  },
  computed: {
    ...mapGetters({
      spinnerMyAgency: "isLoading",
    }),
  },
  methods: {
    async getMyAgency() {
      const vue = this;
      await agencyService
        .getAgence()
        .then((res) => {
          vue.agency = res.data.agency;
        })
        .catch((err) => {
          // Handler error
        });
    },
  },
};
